import { ApiError, apiRequest, ErrorCode, getErrorMessage } from './client';

// Error codes and error-related type definitions moved to client.ts
export { ApiError, ErrorCode, getErrorMessage };

// Playlist type definition
export interface Playlist {
  id: number;
  since: string;
  until: string;
  url?: string;
  src: string;
  duration: number;
  imp: string;
  err: string;
  width: number;
  height: number;
  mimeType: string; // Modified from snake_case to camelCase
  status: number;
  programId?: number; // Modified from snake_case to camelCase
  createdAt?: string;
  statsStartAt?: string;
  statsQuarterAt?: string;
  statsHalfAt?: string;
  statsThreeQuartersAt?: string;
  statsCompleteAt?: string;
  statsErrorAt?: string;
}

// Standard API response format type definition
export interface StandardResponse<T> {
  data: T;
  meta: {
    [key: string]: unknown;
    pagination?: {
      total: number;
      limit: number;
      offset: number;
    };
    message?: string;
  };
}

// Playlist list response type definition
export type PlaylistListResponse = StandardResponse<Playlist[]>;

// Single playlist response type definition
export type PlaylistResponse = StandardResponse<Playlist>;

// Create response type definition
export type CreateResponse = StandardResponse<{ id: number }>;

// Update/delete response type definition
export type ActionResponse = StandardResponse<{ message: string }>;

/**
 * Get playlist list
 */
export const getPlaylists = (
  at?: string,
  since?: string,
  until?: string,
  programId?: number,
  limit?: number,
  offset?: number,
  sort?: string,
): Promise<PlaylistListResponse> => {
  return apiRequest<PlaylistListResponse>({
    method: 'GET',
    path: '/cms/playlists',
    params: {
      at,
      since,
      until,
      programId: programId ? programId.toString() : undefined,
      limit: limit ? limit.toString() : undefined,
      offset: offset ? offset.toString() : undefined,
      sort,
    },
  });
};

/**
 * Get playlist by ID
 */
export const getPlaylist = (id: number): Promise<PlaylistResponse> => {
  return apiRequest<PlaylistResponse>({
    method: 'GET',
    path: `/cms/playlists/${id}`,
  });
};
